import { DateObject } from 'react-multi-date-picker';

export const weekDays = ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'];

export const toEnglishNumbers = (str) => {
   let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
   let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

   for (let i = 0; i < 10; i++) {
      str = str.replaceAll(persianNumbers[i], i).replaceAll(arabicNumbers[i], i);
   }
   return str;
};

export const getFormattedDate = (date) => {
   if (date instanceof DateObject) {
      let dt = toEnglishNumbers(date.toDate().toLocaleDateString('fa-IR'));
      let temp = dt.split('/');

      if (parseInt(temp[1]) < 10 && parseInt(temp[2]) < 10) {
         dt = temp[0] + '/0' + temp[1] + '/0' + temp[2];
      }
      if (parseInt(temp[1]) < 10) {
         dt = temp[0] + '/0' + temp[1] + '/' + temp[2];
      }
      if (parseInt(temp[2]) < 10) {
         dt = temp[0] + '/' + temp[1] + '/0' + temp[2];
      }
      return dt;
   }
   return date;
};